import { render, staticRenderFns } from "./CallLogList.vue?vue&type=template&id=2d1ce7c0&"
import script from "./CallLogList.vue?vue&type=script&lang=ts&"
export * from "./CallLogList.vue?vue&type=script&lang=ts&"
import style0 from "./CallLogList.vue?vue&type=style&index=0&id=2d1ce7c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports